import React, { Fragment } from 'react'

export default function Footer() {
    return (
        <Fragment>
            <footer className="u-footer d-md-flex align-items-md-center text-center text-md-left text-muted">
                {/* <p className="h5 mb-2 mb-md-0">More freebies on <a className="link-muted" href="https://htmlstream.com/" target="_blank">Htmlstream</a></p>

                <p className="h5 mb-0 ml-auto">
                    &copy; 2018 <a className="link-muted" href="https://htmlstream.com/" target="_blank">Htmlstream</a>. All Rights Reserved.
					</p> */}
            </footer>
        </Fragment>
    )
}
